"use client";

import DollarIcon from "@/assets/dollar.svg";
import LinkIcon from "@/assets/link-external.svg";
import OverviewCard from "@/components/OverviewCard";
import PrimaryCard from "@/components/PrimaryCard";
import SecondaryCard from "@/components/SecondaryCard";
import SecondaryButton from "@/components/SecondaryButton";
import Card from "@/components/Card";
import ExploreSpheron from "@/components/ExploreSpheron";
// import StakingTab from "@/components/StakingTab";
// import WithdrawEscrow from "@/components/WithdrawEscrow";
import Redeem from "@/components/Redeem";
import { getWithdrawalRequestsForAddress } from "@/services/subgraph";
import { useCallback, useEffect, useState } from "react";
import { useActiveAccount } from "thirdweb/react";
import {
  getUsponBalance,
  getUsponInfo,
  hasUserRedeemed,
} from "@/services/uspon";
import { getSPONBalance } from "@/services/spon";
import { formatUnits } from "ethers";
import { DEXS } from "@/config/dexes";
import { EXCHANGE_RATE, isTrafficOverload, TOKENOMICS_URL } from "@/config";
import TrafficOverloadPage from "@/components/TrafficOverloadPage";

// const tabList = [
//   { id: 0, label: "WITHDRAW" },
//   { id: 1, label: "REDEEM uSPON" },
// ];

export default function Home() {
  // const [selectedTab, setSelectedTab] = useState(0);
  const [uSponBalance, setuSponBalance] = useState<number | null>(null);
  const [uSponWalletBalance, setuSponWalletBalance] = useState<number | null>(
    null
  );
  const [sponBalance, setSponBalance] = useState<number | null>(null);
  // const [uSponTotalSupply, setUsponTotalSupply] = useState<number | null>(null);
  // const [convertedAsset, setConvertedAsset] = useState<number | null>(null);
  const [isBalanceLoading, setIsBalanceLoading] = useState<boolean>(false);
  // const [poolData, setPoolData] = useState<{
  //   activeStakers: number;
  //   totalDepositBalance: number;
  // }>({ activeStakers: 0, totalDepositBalance: 0 });

  const activeAccount = useActiveAccount();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [subgraphData, setSubgraphData] = useState<Awaited<
    ReturnType<typeof getWithdrawalRequestsForAddress>
  > | null>(null);

  const [hasRedeemed, setHasRedeemed] = useState<boolean | null>(null);
  const [isRedeemCheckLoading, setIsRedeemCheckLoading] =
    useState<boolean>(false);
  const [isUsponEligibileAmountLoading, setIsUsponEligibileAmountLoading] =
    useState<boolean>(false);

  const resetAccountDetails = () => {
    setuSponBalance(null);
    setuSponWalletBalance(null);
    setSponBalance(null);
    setSubgraphData(null);
  };

  useEffect(() => {
    if (!activeAccount?.address) resetAccountDetails();

    const fetchBalance = async () => {
      setIsBalanceLoading(true);
      try {
        if (activeAccount) {
          const usponWalletBalance = await getUsponBalance(activeAccount);
          setuSponWalletBalance(Number(formatUnits(usponWalletBalance, 6)));
          const sponBalance = await getSPONBalance(activeAccount);
          setSponBalance(Number(formatUnits(sponBalance, 18)));
          // const totalSupply = await getUsponTotalSupply();
          // setUsponTotalSupply(Number(formatUnits(totalSupply, 6)));
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        setIsBalanceLoading(false);
      }
    };

    const checkRedeemed = async () => {
      setIsRedeemCheckLoading(true);
      try {
        if (activeAccount) {
          const redeemed = await hasUserRedeemed(activeAccount);
          setHasRedeemed(redeemed);
        } else {
          setHasRedeemed(null);
        }
      } catch (error) {
        setHasRedeemed(null);
        console.error("Error checking hasUserRedeemed:", error);
      } finally {
        setIsRedeemCheckLoading(false);
      }
    };

    fetchBalance();
    checkRedeemed();
    document.addEventListener("refreshBalance", fetchBalance);
    document.addEventListener("refreshRedeem", checkRedeemed);
    return () => {
      document.removeEventListener("refreshBalance", fetchBalance);
      document.removeEventListener("refreshRedeem", checkRedeemed);
    };
  }, [activeAccount]);

  const fetchUsponEligibileAmount = useCallback(async () => {
    if (activeAccount) {
      setIsUsponEligibileAmountLoading(true);
      try {
        const { success, usponInfo } = await getUsponInfo(
          activeAccount.address
        );
        if (success) {
          setuSponBalance(Number(usponInfo.shares));
        } else {
          setuSponBalance(null);
        }
      } catch (e) {
        console.log("error while fetching withdraw details: ", e);
        setuSponBalance(null);
      } finally {
        setIsUsponEligibileAmountLoading(false);
      }
    }
  }, [activeAccount]);

  useEffect(() => {
    fetchUsponEligibileAmount();
  }, [fetchUsponEligibileAmount]);

  // If traffic overload is enabled, show the overload page
  if (isTrafficOverload) {
    return <TrafficOverloadPage />;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex flex-col justify-between">
          <PrimaryCard
            title={"Redeemable uSPON"}
            description={
              <>
                {activeAccount?.address && uSponBalance !== null ? (
                  <>{hasRedeemed ? "0" : uSponBalance.toFixed(2)} uSPON</>
                ) : (
                  "N/A"
                )}
              </>
            }
            tagTitle="Wallet Balance:"
            tagDescription={`${
              sponBalance
                ? `${sponBalance.toLocaleString("en-US")} SPON`
                : "N/A"
            }`}
            // showTag={!!activeAccount?.address}
            showTag={false}
            backgroundImageUrl="/staked-card-bg.svg"
            tagLoading={isBalanceLoading || isUsponEligibileAmountLoading}
            loading={isBalanceLoading || isUsponEligibileAmountLoading}
          />
          <PrimaryCard
            title={"My SPON Balance"}
            description={
              sponBalance !== null
                ? `${sponBalance.toLocaleString("en-US")} SPON`
                : "N/A"
            }
            tagTitle="Cooldown Status:"
            // tagDescription={
            //   isInCooldown ? formattedRemainingTime : "No active cooldown"
            // }
            showTag={false}
            backgroundImageUrl="/reward-card-bg.svg"
            tagLoading={false}
            loading={isBalanceLoading || isUsponEligibileAmountLoading}
          />
          <SecondaryCard
            title={"Conversion Rate"}
            description={`1 uSPON = ${EXCHANGE_RATE} SPON`}
            loading={false}
          />
        </div>
        <div className="py-4 px-4 md:px-6 flex flex-col gap-3 border border-card-border bg-card-background h-[500px]">
          {isRedeemCheckLoading || isUsponEligibileAmountLoading ? (
            <div className="flex flex-1 flex-col items-center justify-between px-4 py-2 gap-2">
              <div className="w-full animate-pulse flex flex-row gap-2 justify-center">
                <div className="basis-1/2 h-[42px] bg-white/10 rounded" />
              </div>
              <div className="w-full">
                <div className="animate-pulse flex flex-col gap-20">
                  <div className="h-20 bg-white/10 rounded" />
                  <div className="h-20 bg-white/10 rounded" />
                </div>
              </div>
              <div className="w-full animate-pulse h-[52px] bg-white/10 rounded" />
            </div>
          ) : hasRedeemed ? (
            <div className="flex flex-1 items-center justify-center text-white text-lg text-center">
              You have successfully redeemed your uSPON.
              <br />
              Thank you!
            </div>
          ) : !isUsponEligibileAmountLoading &&
            uSponBalance === null &&
            activeAccount?.address ? (
            <div className="flex flex-1 items-center justify-center text-white text-lg text-center">
              You are not eligible to redeem any uSPON.
            </div>
          ) : (
            <>
              {/* <StakingTab
                tabList={tabList}
                selectedTab={selectedTab}
                defaultTab={1}
                onClick={(id) => {
                  setSelectedTab(id);
                }}
              /> */}
              <h1 className="text-white text-xl text-center font-inter font-semibold tracking-wider pb-2">
                REDEEM uSPON
              </h1>
              <Redeem
                isLoading={isBalanceLoading}
                uSponBalance={
                  activeAccount?.address && hasRedeemed ? 0 : uSponBalance
                }
                uSponWalletBalance={uSponWalletBalance}
              />
              {/* {
                {
                  0: (
                    <WithdrawEscrow
                      isLoading={isBalanceLoading}
                      uSponBalance={uSponBalance}
                    />
                  ),
                  1: (
                    <Redeem
                      isLoading={isBalanceLoading}
                      uSponBalance={uSponBalance}
                    />
                  ),
                }[selectedTab]
              } */}
            </>
          )}
        </div>
      </div>

      <OverviewCard
        title={"Overview"}
        description={
          <>
            You can convert your <span className="text-white">uSPON</span> to{" "}
            <span className="text-white">SPON</span> at the conversion rate
            shown above. It's our way of saying thank you for sharing your
            resources, keeping your node running smoothly, and helping power
            real workloads on the network. We truly appreciate your continued
            support and hope you'll keep contributing your compute to the
            Spheron mission.
          </>
        }
      />

      <div className="w-full border border-card-border bg-card-background backdrop-blur-[10px] p-4 flex flex-col md:flex-row gap-6 md:gap-3 items-center">
        <div className="text-white font-jetbrans-mono text-sm">
          Take a deep dive into our tokenomics to understand how our token plays
          a key role in powering the Spheron Network.
        </div>
        <SecondaryButton
          className="max-w-full md:max-w-[160px]"
          onClick={() => {
            window.open(TOKENOMICS_URL, "_blank");
          }}
          variant="light"
        >
          Check it out
        </SecondaryButton>
      </div>

      <OverviewCard
        title={"What is uSPON?"}
        description={
          <>
            <span className="text-white">uSPON</span> is a non-tradable utility
            token used solely for deployments within the Spheron ecosystem. It
            streamlines billing and enhances transparency across the network. By
            continuing to earn uSPON as a node operator, you unlock the
            opportunity to earn additional rewards and deepen your involvement
            in the Spheron Network.
          </>
        }
      />

      <Card className="w-full self-start flex flex-col gap-4 p-4 !px-4 !items-start">
        <h2 className="text-2xl md:font-semibold flex items-center gap-2">
          <DollarIcon className="h-6 w-6" /> BUY SPON
        </h2>
        <div className="flex gap-4 w-full flex-col md:flex-row">
          {DEXS.map((item) => {
            return (
              <a
                key={item.id}
                className="basis-[24%]"
                href={item.link}
                target="_blank"
              >
                <Card className="text-white hover:border-[#4C4C40] flex !items-center gap-2 !px-4 !py-2 !bg-black">
                  {item.logo}
                  {item.name}
                  <LinkIcon className="ml-auto w-4 h-4" />
                </Card>
              </a>
            );
          })}
        </div>
      </Card>

      <ExploreSpheron isEligible />

      {/* <Note
        title="⚠️️️ Important Note"
        description={
          <>
            Your unstaked tokens are in the{" "}
            <span className="font-bold text-white">7-day cooldown period</span>.
            After this period ends, you'll be able to withdraw your $SPON.
          </>
        }
      /> */}
    </div>
  );
}
